const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const getPaymentType = (checkoutId) => (checkoutId ? "Card" : "Cash on Delivery");

const RecentOrdersTable = ({ orders = [], loading }) => {
  return (
    <div className="recent-orders-section">
      <div className="section-header">
        <h3>Recent Orders</h3>
      </div>

      <div className="orders-table-container">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Date</th>
              <th>Product</th>
              <th>Customer Name</th>
              <th>Email ID</th>
              <th>Payment Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr>
                <td colSpan={7}>Loading recent orders...</td>
              </tr>
            )}

            {!loading && orders.length === 0 && (
              <tr>
                <td colSpan={7}>No recent orders found.</td>
              </tr>
            )}

            {!loading &&
              orders.map((order) => {
                const customer = order.adcustomer || {};
                const items = order.adcart || [];

                return (
                  <tr key={order.id}>
                    <td className="order-id-cell">#ORD{order.id}</td>
                    <td>{formatDate(order.created_at)}</td>
                    <td>
                      <div className="product-cell">
                        <span>
                          {items.length > 1
                            ? `${items.length} items`
                            : items[0]?.adproduct?.name || "-"}
                        </span>
                      </div>
                    </td>
                    <td>{customer.fullName || "-"}</td>
                    <td className="email-cell">{customer.email || "-"}</td>
                    <td>{getPaymentType(order.checkoutId)}</td>
                    <td>
                      <span
                        className={`status-badge ${String(
                          order.status || ""
                        ).toLowerCase()}`}
                      >
                        ● {order.status || "-"}
                      </span>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RecentOrdersTable;